module.exports = __webpack_public_path__ + "static/media/WBTC-logo.acea5032.png";